import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function emailSameAsInitial(initialEmail: string, isOk: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.parent && !isOk) {
            return !!control.parent &&
            !!control.parent.value &&
            control.value === initialEmail
            ? { matching: true }
            : null;
        }
        return null;
    };
}